export default __webpack_public_path__ + "static/media/input-svgrepo-com.403bd1ef.svg";